import React from 'react';
import './HostingServices.css';

function HostingServices() {
  return (
    <div className="hosting-services-page">
      <div className="hosting-container">
        <h1 className="hosting-title">Hosting & Services</h1>
        <p className="hosting-subtitle">
          Professional hosting solutions and services for your projects
        </p>

        <div className="services-grid">
          <div className="service-card">
            <div className="service-icon">🌐</div>
            <h3>Web Hosting</h3>
            <p className="service-price">Starting at $5/month</p>
            <ul className="service-features">
              <li>99.9% Uptime Guarantee</li>
              <li>Unlimited Bandwidth</li>
              <li>SSD Storage</li>
              <li>Free SSL Certificate</li>
              <li>24/7 Support</li>
              <li>cPanel Access</li>
            </ul>
            <button className="service-btn">Get Started</button>
          </div>

          <div className="service-card featured">
            <div className="service-badge">Popular</div>
            <div className="service-icon">☁️</div>
            <h3>Cloud Hosting</h3>
            <p className="service-price">Starting at $15/month</p>
            <ul className="service-features">
              <li>Scalable Resources</li>
              <li>Auto-scaling</li>
              <li>Load Balancing</li>
              <li>DDoS Protection</li>
              <li>Daily Backups</li>
              <li>99.99% SLA</li>
            </ul>
            <button className="service-btn">Get Started</button>
          </div>

          <div className="service-card">
            <div className="service-icon">💾</div>
            <h3>VPS Hosting</h3>
            <p className="service-price">Starting at $10/month</p>
            <ul className="service-features">
              <li>Full Root Access</li>
              <li>Choose Your OS</li>
              <li>Dedicated Resources</li>
              <li>Snapshots Included</li>
              <li>IPv6 Support</li>
              <li>24/7 Monitoring</li>
            </ul>
            <button className="service-btn">Get Started</button>
          </div>

          <div className="service-card">
            <div className="service-icon">🗄️</div>
            <h3>Database Hosting</h3>
            <p className="service-price">Starting at $8/month</p>
            <ul className="service-features">
              <li>MongoDB, MySQL, PostgreSQL</li>
              <li>Automated Backups</li>
              <li>High Availability</li>
              <li>Replication Support</li>
              <li>Performance Monitoring</li>
              <li>Secure Connections</li>
            </ul>
            <button className="service-btn">Get Started</button>
          </div>

          <div className="service-card">
            <div className="service-icon">📧</div>
            <h3>Email Hosting</h3>
            <p className="service-price">Starting at $3/month</p>
            <ul className="service-features">
              <li>Custom Domain Email</li>
              <li>Unlimited Mailboxes</li>
              <li>Spam Protection</li>
              <li>Webmail Access</li>
              <li>IMAP/POP3 Support</li>
              <li>Email Forwarding</li>
            </ul>
            <button className="service-btn">Get Started</button>
          </div>

          <div className="service-card">
            <div className="service-icon">🔒</div>
            <h3>SSL Certificates</h3>
            <p className="service-price">Free - $50/year</p>
            <ul className="service-features">
              <li>Free SSL Included</li>
              <li>Wildcard Certificates</li>
              <li>EV SSL Available</li>
              <li>Auto-renewal</li>
              <li>Multi-domain Support</li>
              <li>24/7 Support</li>
            </ul>
            <button className="service-btn">Get Started</button>
          </div>
        </div>

        <div className="hosting-features">
          <h2>Why Choose Our Hosting?</h2>
          <div className="features-list">
            <div className="feature-item">
              <span className="feature-icon">⚡</span>
              <div>
                <h4>Lightning Fast</h4>
                <p>Optimized servers for maximum performance</p>
              </div>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🛡️</span>
              <div>
                <h4>Secure</h4>
                <p>Enterprise-grade security and DDoS protection</p>
              </div>
            </div>
            <div className="feature-item">
              <span className="feature-icon">📈</span>
              <div>
                <h4>Scalable</h4>
                <p>Grow your resources as your needs grow</p>
              </div>
            </div>
            <div className="feature-item">
              <span className="feature-icon">💬</span>
              <div>
                <h4>24/7 Support</h4>
                <p>Expert support team available around the clock</p>
              </div>
            </div>
          </div>
        </div>

        <div className="contact-section">
          <h2>Need Custom Hosting Solutions?</h2>
          <p>Contact us for enterprise hosting, dedicated servers, or custom configurations.</p>
          <a 
            href="https://discord.gg/RXVZZWzMcq" 
            target="_blank" 
            rel="noopener noreferrer"
            className="contact-btn"
          >
            Contact Us on Discord
          </a>
        </div>
      </div>
    </div>
  );
}

export default HostingServices;

